import { gql } from 'apollo-angular';

export const MAP_PARTNERS_BOOKINGS_QUERY = gql`
  query mapPartnerBookings {
    mapPartnerBookings {
      partnerId
      firstName
      middleName
      lastName
      latitude
      longitude
      locationHeading
      vehicleType
      partnerVehicles {
        partnerVehicleId
        yearModel
        vehicleModel
        vehicle {
          category
          seatCount
        }
        isOkRide
        isExpress
        isMototaxi
      }
      bookingRide {
        bookingRideId
        rideType
        status
      }
      bookingExpress {
        bookingExpressId
        status
      }
    }
  }
`;